module.exports = __webpack_public_path__ + "static/img/02057B_2_3_4_R_20200316_LC.7a6c118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02057B_2_3_4_R_20200316_LC.png
// module id = UHlP
// module chunks = 0